/* ═══════════════════════════════════
   Ochsenleder — Maßkrugmarkierer JS
   ═══════════════════════════════════ */
(function(){

  /* ── Gallery ── */
  var VISIBLE = 5;
  var thumbOffset = 0;
  var activeIndex = 0;
  var allImages = [];
  var displayImages = [];

  if (window.mrkAllImages && window.mrkAllImages.length) {
    allImages = window.mrkAllImages;
  }
  displayImages = allImages.slice();

  function renderThumbs() {
    var grid = document.getElementById('mrkThumbsGrid');
    if (!grid || displayImages.length === 0) return;
    var slice = displayImages.slice(thumbOffset, thumbOffset + VISIBLE);
    grid.innerHTML = slice.map(function(img, i) {
      var gi = thumbOffset + i;
      return '<div class="ox-thumb' + (gi === activeIndex ? ' active' : '') + '" onclick="window._mrkSelectThumb(' + gi + ')">' +
        '<img src="' + img.src + '" alt=""></div>';
    }).join('');
    var prev = document.getElementById('mrkThumbPrev');
    var next = document.getElementById('mrkThumbNext');
    if (prev) prev.style.display = thumbOffset > 0 ? 'flex' : 'none';
    if (next) next.style.display = thumbOffset + VISIBLE < displayImages.length ? 'flex' : 'none';
  }

  window._mrkSelectThumb = function(index) {
    activeIndex = index;
    var mainImg = document.getElementById('mrkMainImg');
    if (mainImg && displayImages[index]) mainImg.src = displayImages[index].src;
    var lb = document.getElementById('mrkLightbox');
    var lbImg = document.getElementById('mrkLbImg');
    if (lbImg && lb && lb.classList.contains('open')) lbImg.src = displayImages[index].src;
    renderThumbs();
    updateArrows();
  };

  function updateArrows() {
    var prev = document.querySelector('.ox-gallery-arrow--prev');
    var next = document.querySelector('.ox-gallery-arrow--next');
    if (prev) prev.style.display = activeIndex > 0 ? 'flex' : 'none';
    if (next) next.style.display = activeIndex < displayImages.length - 1 ? 'flex' : 'none';
  }

  window._mrkGalleryNav = function(dir) {
    var newIndex = activeIndex + dir;
    if (newIndex < 0 || newIndex >= displayImages.length) return;
    if (thumbOffset > newIndex) thumbOffset = newIndex;
    if (newIndex >= thumbOffset + VISIBLE) thumbOffset = newIndex - VISIBLE + 1;
    window._mrkSelectThumb(newIndex);
  };

  window._mrkShiftThumbs = function(dir) {
    thumbOffset = Math.max(0, Math.min(displayImages.length - VISIBLE, thumbOffset + dir));
    renderThumbs();
  };

  renderThumbs();
  updateArrows();


  /* ── Pack-Anzahl aus Variantenoption ermitteln ── */
  function getPackCount(variant) {
    if (!variant) return 1;
    var sources = [variant.title].concat(variant.options || []);
    for (var i = 0; i < sources.length; i++) {
      var m = String(sources[i]).match(/(\d+)/);
      if (m) return parseInt(m[1]);
    }
    return 1;
  }


  /* ── Aktuelle Variante suchen ── */
  function currentVariant() {
    var variants = window.mrkVariantData || [];
    var opts = window.mrkSelectedOptions || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i]; var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return variants[0] || null;
  }


  /* ── Variante anwenden (ID + Preis) ── */
  function applyVariant(v) {
    if (!v) return;
    var idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (idInput) idInput.value = v.id;
    var priceEl = document.getElementById('mrkPrice');
    if (priceEl) priceEl.textContent = (v.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    if (v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src.replace(/\?.*$/, '') + '?width=1200';
      var mainImg = document.getElementById('mrkMainImg');
      if (mainImg) mainImg.src = src;
    }
  }


  /* ── Pack-Button Klick ── */
  window._mrkVariantOption = function(optionIndex, value, btnEl) {
    var opts = window.mrkSelectedOptions || [];
    opts[optionIndex] = value;
    window.mrkSelectedOptions = opts;

    // Aktiven Button markieren (nur innerhalb der gleichen Option)
    if (btnEl) {
      var siblings = btnEl.parentElement.querySelectorAll('.mrk-pack-btn');
      siblings.forEach(function(b) { b.classList.remove('active'); });
      btnEl.classList.add('active');
    }

    applyVariant(currentVariant());

    // Namenfelder aktualisieren wenn Gravur aktiv
    var toggle = document.getElementById('mrkGravurToggle');
    if (toggle && toggle.checked) {
      renderNameFelder(getPackCount(currentVariant()));
    }
  };


  /* ── Gravur Toggle ── */
  window._mrkToggleGravur = function(cb) {
    var gravurIdx = window.mrkGravurOptionIdx;
    var opts = window.mrkSelectedOptions || [];

    if (gravurIdx >= 0) {
      // Gravur-Option in Varianten vorhanden → Variante wechseln
      opts[gravurIdx] = cb.checked ? 'Mit Gravur' : 'Ohne Gravur';
      window.mrkSelectedOptions = opts;
      applyVariant(currentVariant());
    }

    // Namenfelder ein-/ausblenden
    var container = document.getElementById('mrkNameFelder');
    if (container) {
      container.style.display = cb.checked ? 'flex' : 'none';
      if (cb.checked) renderNameFelder(getPackCount(currentVariant()));
    }
  };


  /* ── Namenfelder rendern ── */
  function renderNameFelder(count) {
    var container = document.getElementById('mrkNameFelder');
    if (!container) return;
    var html = '';
    for (var i = 1; i <= count; i++) {
      var label = count === 1 ? 'Name' : 'Markierer ' + i;
      html += '<div class="mrk-gravur-field-group">' +
        '<label>' + label + '</label>' +
        '<input type="text" name="properties[Name ' + i + ']" maxlength="10" ' +
        'placeholder="z. B. Steffi" class="mrk-gravur-input">' +
        '</div>';
    }
    container.innerHTML = html;
  }

  // Namenfelder beim Laden vorbereit (falls Gravur-Option aktiv)
  (function() {
    var v = currentVariant();
    if (v) renderNameFelder(getPackCount(v));
  })();


  /* ── Gravur Popup ── */
  window._mrkOpenGravurPopup = function() {
    var el = document.getElementById('mrkGravurPopup');
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window._mrkCloseGravurPopup = function() {
    var el = document.getElementById('mrkGravurPopup');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };


  /* ── Lightbox ── */
  window._mrkOpenLightbox = function() {
    var lb = document.getElementById('mrkLightbox');
    var img = document.getElementById('mrkLbImg');
    if (lb && img && displayImages[activeIndex]) {
      img.src = displayImages[activeIndex].src;
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  };
  window._mrkCloseLightbox = function() {
    var lb = document.getElementById('mrkLightbox');
    if (lb) { lb.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window._mrkLightboxNav = function(dir) {
    var newIndex = activeIndex + dir;
    if (newIndex < 0 || newIndex >= displayImages.length) return;
    window._mrkSelectThumb(newIndex);
  };


  /* ── Akkordeons ── */
  window._oxToggleAcc = window._oxToggleAcc || function(id) {
    var item = document.getElementById(id);
    if (!item) return;
    var isOpen = item.classList.contains('open');
    item.classList.toggle('open');
    var icon = item.querySelector('.ox-accordion-icon');
    if (icon) icon.textContent = isOpen ? '+' : '−';
  };


  /* ── Keyboard ── */
  document.addEventListener('keydown', function(e) {
    var lbOpen = document.getElementById('mrkLightbox') &&
                 document.getElementById('mrkLightbox').classList.contains('open');
    if (e.key === 'Escape') { _mrkCloseLightbox(); _mrkCloseGravurPopup(); }
    else if (e.key === 'ArrowLeft')  { if (lbOpen) _mrkLightboxNav(-1); else _mrkGalleryNav(-1); }
    else if (e.key === 'ArrowRight') { if (lbOpen) _mrkLightboxNav(1);  else _mrkGalleryNav(1); }
  });

})();
